var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import dayjs from 'dayjs';
import { CreativeRepository } from '@/models/Creative';
var CreativeScheduleFormModel = /** @class */ (function () {
    function CreativeScheduleFormModel(item) {
        if (item === void 0) { item = {}; }
        var _a = item, startTime = _a.startTime, endTime = _a.endTime, _b = _a.creatives, creatives = _b === void 0 ? [] : _b;
        this.startTime = startTime;
        this.endTime = endTime;
        this.creatives = creatives.map(CreativeSchduleCreativeFormModel.assign);
    }
    CreativeScheduleFormModel.assign = function (item) {
        return new CreativeScheduleFormModel(item);
    };
    Object.defineProperty(CreativeScheduleFormModel.prototype, "startDate", {
        get: function () {
            return this.getDate(this.startTime);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CreativeScheduleFormModel.prototype, "startDateTime", {
        get: function () {
            return this.getDateTime(this.startTime);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CreativeScheduleFormModel.prototype, "endDate", {
        get: function () {
            return this.getDate(this.endTime);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CreativeScheduleFormModel.prototype, "endDateTime", {
        get: function () {
            return this.getDateTime(this.endTime);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CreativeScheduleFormModel.prototype, "isInfinite", {
        get: function () {
            return !this.startTime && !this.endTime;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CreativeScheduleFormModel.prototype, "noCreativesWarning", {
        get: function () {
            return this.creatives.length === 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CreativeScheduleFormModel.prototype, "isStartTimeAfterEndTime", {
        get: function () {
            if (!this.startTime || !this.endTime) {
                return false;
            }
            return dayjs(this.startTime).isAfter(this.endTime);
        },
        enumerable: false,
        configurable: true
    });
    CreativeScheduleFormModel.prototype.isNotInCampaignBudgetPeriod = function (campaignBudgetStartTime, campaignBudgetEndTime) {
        var isNotInStartTime = this.startTime
            ? dayjs(campaignBudgetStartTime).isAfter(this.startTime) ||
                dayjs(campaignBudgetEndTime).isBefore(this.startTime)
            : false;
        var isNotInEndTime = this.endTime
            ? dayjs(campaignBudgetEndTime).isBefore(this.endTime) ||
                dayjs(campaignBudgetStartTime).isAfter(this.endTime)
            : false;
        return isNotInStartTime || isNotInEndTime;
    };
    CreativeScheduleFormModel.prototype.getDate = function (dateTime) {
        return dateTime ? dayjs(dateTime).format('YYYY-MM-DD') : undefined;
    };
    CreativeScheduleFormModel.prototype.getDateTime = function (dateTime) {
        return dateTime ? dayjs(dateTime).format('HH:mm:ss') : undefined;
    };
    CreativeScheduleFormModel.prototype.fetchCreatives = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, CreativeRepository.findByIdsWithFolderInfo(this.creatives)];
                    case 1:
                        _a.creatives = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return CreativeScheduleFormModel;
}());
export { CreativeScheduleFormModel };
var CreativeSchduleCreativeFormModel = /** @class */ (function () {
    function CreativeSchduleCreativeFormModel(item) {
        if (item === void 0) { item = {}; }
        var _a = item, id = _a.id, ownerProfileId = _a.ownerProfileId, creativeFolderId = _a.creativeFolderId;
        this.id = id;
        this.ownerProfileId = ownerProfileId;
        this.creativeFolderId = creativeFolderId;
    }
    CreativeSchduleCreativeFormModel.assign = function (item) {
        return new CreativeSchduleCreativeFormModel(item);
    };
    return CreativeSchduleCreativeFormModel;
}());
export { CreativeSchduleCreativeFormModel };
